import { render, staticRenderFns } from "./supplier_management_confirm.vue?vue&type=template&id=31f8f971"
import script from "./supplier_management_confirm.vue?vue&type=script&lang=js"
export * from "./supplier_management_confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports